import { ValidationType } from '@enums';
import { createValidationSchema } from '@utils';

export const CREATE_NEW_PASSWORD_SCHEMA = createValidationSchema({
  email: {
    required: true,
    pattern: ValidationType.EMAIL,
  },
  password: {
    required: true,
    minLength: 8,
  },
  confirm_password: {
    required: true,
    customRule: {
      validator: ({ value, formData }) => value === formData.password,
      message: 'validation:changePassword.passwordsMustMatch',
    },
  },
});
